import { useNavigate } from 'react-router-dom';

import { useLocationState } from './useLocationState';

export const useModalState = () => {
  const [state, setState] = useLocationState(false);
  const navigate = useNavigate();

  const open = () => {
    setState(true);
  };
  const close = () => {
    navigate(-1);
  };

  const updateState = (value: boolean) => {
    if (value) {
      open();
    } else {
      close();
    }
  };

  return [state, updateState] as const;
};
